export default {"src":"/_next/static/media/COST.695350c8.svg","height":18,"width":18};